export default __webpack_public_path__ + "static/media/full-screen-image-4.a1bc03f2.jpg";